import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageEN from './locale/en.translate.json';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: languageEN as any,
    },
    fallbackLng: 'en',
    debug: false,
    keySeparator: '.',

    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
  });

export default i18n;
